
export const wrapWithCaller = (payload, caller) => {
    return `${payload} Caller is ${caller ? caller : 'unknown'}`;
};